import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PublicLayout from 'src/layouts/PublicLayout';

function useMatchGoogleTranslate() {
  const { pathname } = useLocation();

  useEffect(() => {
    const html = document.documentElement;
    if (pathname.startsWith('/match')) {
      html.removeAttribute('translate');    // allow Google-Translate for /match routes
    } else {
      html.setAttribute('translate', 'no'); // block everywhere else
    }
  }, [pathname]);
}

const PublicRoot = () => {
  useMatchGoogleTranslate();
  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
};

export default PublicRoot;
